<template>
  <v-snackbar
    v-model="isVisible"
    :timeout="-1"
    location="top"
    color="primary"
    variant="flat"
  >
    <div class="d-flex align-center justify-space-between w-100">
      <span>{{ $t('pwa.update_available') }}</span>
      <v-btn
        variant="outlined"
        size="small"
        color="white"
        :loading="isUpdating"
        @click="applyUpdate"
      >
        {{ $t('pwa.update_button') }}
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "PwaUpdateBanner",
  data() {
    return {
      isVisible: false,
      isUpdating: false,
      registration: null,
    };
  },
  created() {
    document.addEventListener("swUpdated", this.onSwUpdated);
  },
  beforeUnmount() {
    document.removeEventListener("swUpdated", this.onSwUpdated);
  },
  methods: {
    onSwUpdated(event) {
      this.registration = event.detail;
      this.isVisible = true;
    },
    applyUpdate() {
      this.isUpdating = true;
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
        this.registration.waiting.addEventListener("statechange", (e) => {
          if (e.target.state === "activated") {
            window.location.reload();
          }
        });
      } else {
        window.location.reload();
      }
    },
  },
};
</script>
